import { Hide, HStack, Show, Spinner, VStack } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { ActiveChat } from "../../../components/card/ActiveChat";
import { Empty } from "../../../components/card/Empty";
import { ListChat } from "../../../components/card/ListChat";
import useScreenWidth from "../../../lib/useScreenWidth";
import { isUuid } from "../../../utils/helperFunction";
import MobileListChat from "../../../components/MobileListChat";

export const SupplierChat = () => {
  const [isChange, setIsChange] = useState<boolean>(false);
  const [selectedChat, setSelectedChat] = useState<string | number | undefined>(
    undefined
  );
  const [newSelectedChat, setNewSelectedChat] = useState<
    string | number | undefined
  >(undefined);
  const [chatLoading, setChatLoading] = useState<boolean>(false);

  useEffect(() => {
    setSelectedChat(newSelectedChat);
    setChatLoading(false);
  }, [newSelectedChat]);

  return (
    <HStack
      className="chat-page"
      w={"100%"}
      h={"calc(100dvh - 60px)"}
      align={"stretch"}
      gap={0}
      overflowY={"auto"}
    >
      <Show above="md">
        <ListChat
          onSelectedChat={(newChat) => {
            if (selectedChat !== newChat) {
              setSelectedChat(undefined);
              setChatLoading(true);
              setNewSelectedChat(newChat);
            }
          }}
        />
      </Show>
      {selectedChat ? (
        <ActiveChat
          clientRole="buyer"
          setSelectedChat={setSelectedChat}
          selectedChat={selectedChat}
          handleCloseChat={(action) => {
            setNewSelectedChat(undefined);
          }}
          onSendMessage={(id_chat: string) => {
            !isChange ? setIsChange(true) : setIsChange(false);

            if (!isUuid(selectedChat as string) && isUuid(id_chat)) {
              setSelectedChat(id_chat);
            }
          }}
        />
      ) : chatLoading ? (
        <VStack
          w={{ base: "100%", md: "70%" }}
          h={"100%"}
          justify={"center"}
          align={"center"}
        >
          <Spinner size="xl" color="red.500" />
        </VStack>
      ) : (
        <VStack className="right-chat-layout" w={{ base: "100%", md: "70%" }}>
          <Show above="md">
            <Empty
              title={"Mulai Berinteraksi"}
              subtitle="Pilih chat anda terlebih dahulu dan mulai berinteraksi"
              w={"100%"}
              maxW={"300px"}
            />
          </Show>
          <Hide above="md">
            <MobileListChat
              onSelectedChat={(newChat) => {
                setSelectedChat(undefined);
                setChatLoading(true);
                setNewSelectedChat(newChat);
              }}
            />
          </Hide>
        </VStack>
      )}
    </HStack>
  );
};
